<template>
  <div>
    <hshead title="客户签字" bgcolor="#fff"></hshead>
    <div class="swiper" v-if="showSwiper">
      <el-carousel class="swiper-container" :interval="4000" indicator-position="outside" arrow="always" :autoplay="false">
        <el-carousel-item class="swiperItem" key="1">
          <img class="swiperImage" src="https://lshoot-images.oss-cn-shenzhen.aliyuncs.com/lshoot-static/common/signature/sig_temp_1.jpg" />
        </el-carousel-item>
        <el-carousel-item class="swiperItem" key="2">
          <img class="swiperImage" src="https://lshoot-images.oss-cn-shenzhen.aliyuncs.com/lshoot-static/common/signature/sig_temp_2.jpg" />
        </el-carousel-item>
        <el-carousel-item class="swiperItem" key="3">
          <img class="swiperImage" src="https://lshoot-images.oss-cn-shenzhen.aliyuncs.com/lshoot-static/common/signature/sig_temp_3.jpg" />
        </el-carousel-item>
        <el-carousel-item class="swiperItem" key="4">
          <img class="swiperImage" src="https://lshoot-images.oss-cn-shenzhen.aliyuncs.com/lshoot-static/common/signature/sig_temp_4.jpg" />
        </el-carousel-item>
        <el-carousel-item class="swiperItem" key="5">
          <img class="swiperImage" src="https://lshoot-images.oss-cn-shenzhen.aliyuncs.com/lshoot-static/common/signature/sig_temp_5.jpg" />
        </el-carousel-item>
        <el-carousel-item class="swiperItem" key="6">
          <img class="swiperImage" src="https://lshoot-images.oss-cn-shenzhen.aliyuncs.com/lshoot-static/common/signature/sig_temp_6.jpg" />
        </el-carousel-item>
      </el-carousel>
      <!-- 放置一个关闭的按钮 -->

      <el-button icon="el-icon-close" class="close-button" size="60rpx" color="#ffffff" type="cancel" @click="closeSwiper" />
    </div>
    <div class="this-search">
					<div class="this-search-box-left">
            <input class="this-search-input" v-model="tempData.searchContent" placeholder="请输入查询内容"/>
            <van-button type="info" size="large" class="my-btn" @click="overrideSearch">搜索</van-button>
					</div>
					<div class="this-search-box-right">
						<button class="this-search-button-blue" @click="openTemplateImage()">纸质签字模板</button>
					</div>
    </div>
    <div class="order-ul">
      <van-list v-model="loading" :finished="finished" finished-text @load="onLoad">
        <div class="order-li" v-for="(item, index) in list" :key="index" @click="viewDetail(item)">
          <div class="content-box">
            <div class="content-iconp iconp1">{{item.order.shootHotelName}}</div>
            <div class="content-hr"></div>
            <div class="content-iconp iconp2">点击可上传纸质签字页或客户线上签字确认</div>
            <div class="content-hr"></div>
            <div class="content-iconp content-iconp-upload iconp3" v-if="item.order.productShootType != 1">
              <div>{{item.order.plantStartDateing}}</div>
              <div>
                <button class="button-green" v-if="item.order.signatureImgUrl!=null&&item.order.signatureImgUrl!=''">已上传</button>
                <button class="button-red"  v-if="item.order.signatureImgUrl==null||item.order.signatureImgUrl==''">未上传</button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div v-if="finished" class="emptyDataDiv">
        <div class="noMore" v-if="list.length==0">
          <van-icon name="info" color="black"/>
          <p>暂无订单</p>
        </div>
        <div class="noMore" v-else>没有更多了</div>
      </div>
    </div>

    <div class="ref-box" @click="listQuery.pn=1;list=[];getTaskOrderPager()">
      <img src="~@/assets/images/order/Refresh.png" alt />
    </div>

    <!-- 确认接单 -->
    <van-dialog
      v-model="dialogAcceptTaskOrderFormVisible"
      title="确认接单信息"
      show-cancel-button
      @confirm="acceptTaskOrder"
    >
      <van-cell-group v-if="curSelectedRow">
        <van-cell title="拍摄酒店" :value="curSelectedRow.shootHotelName" />
        <van-cell title="拍摄地址" :value="curSelectedRow.shootAddress" />
        <van-cell
          title="预拍摄时间"
          :value="curSelectedRow.plantStartDateing + '至' + curSelectedRow.plantStartDateing"
        />
      </van-cell-group>
    </van-dialog>

     <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span style="color:#304378">任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_earnings.active : icon_earnings.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Order" icon="chart-trending-o">
        <span>我的订单</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_order.active : icon_order.inactive"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Center" icon="chart-trending-o">
        <span>我的</span>
        <template #icon="props">
          <img
            :src="props.active ? icon_user.active : icon_user.inactive"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
import { Toast, List, Button, Dialog, CellGroup, Cell, Icon ,Tabbar, TabbarItem } from "vant";
import { getGrapherTaskOrderPager, acceptTaskOrder } from "@/api/m/grapher";
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//我的订单
import order_icon from "@/assets/images/center/nav-6.png";
import order_icon_act from "@/assets/images/center/nav-6-act.png";
//我的
import user_icon from "@/assets/images/center/nav-7.png";
import user_icon_act from "@/assets/images/center/nav-7-act.png";
//87371599
export default {
  name: "SignatureList",
  data() {
    return {
      active: -1,
      list: [],
      tempData: {},
      showSwiper: false,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      loading: false,
      finished: false,
      listQuery: {
        pn: 1,
        ps: 4
      },
      curSelectedRow: null,
      //接单
      dialogAcceptTaskOrderFormVisible: false,
       icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_order: {
        active: order_icon_act,
        inactive: order_icon,
      },
      icon_user: {
        active: user_icon_act,
        inactive: user_icon,
      },
    };
  },
  methods: {
    onLoad() {
      this.getTaskOrderPager();
    },
    //列表数据
    getTaskOrderPager() {
      getGrapherTaskOrderPager(this.listQuery)
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.listQuery.pn = this.listQuery.pn + 1;
            //
            if (data.totalRecord == 0) {
              this.loading = false;
              this.finished = true;
            } else {
              data.list.map(item => {
                this.list.push(item);
              });
              // 加载状态结束
              this.loading = false;
              // 数据全部加载完成
              if (this.list.length >= data.totalRecord) {
                this.finished = true;
              }
            }
          }
        })
        .catch(response => {
          //this.tips(`${response.msg}`);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    //接任务
    acceptTaskOrderConfirm(row) {
      this.curSelectedRow = row;
      this.dialogAcceptTaskOrderFormVisible = true;
    },
    documentStandard(row) {
      if (row.documentUrl != "") {
        sessionStorage.setItem("_documentUrl", row.documentUrl);
        window.location.href = "/static/pdfShow.html";
      }
    },
    acceptTaskOrder() {
      this.load(true, "加载中...");
      let para = {
        orderId: this.curSelectedRow.id
      };
      acceptTaskOrder(para)
        .then(response => {
          this.load(false);
          const { code, msg, data } = response;
          if (code >= 0) {
            this.tips(`接单成功`);
            //this.listQuery.pn = 1;
            //this.getTaskOrderPager();
            setTimeout(function() {
              window.location.href = window.location.href;
            }, 1000 * 1);
          }
        })
        .catch(response => {
          this.load(false);
          //this.tips(response.msg);
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });
    },
    openTemplateImage() {
      let self = this;
      self.showSwiper = true
    },
    closeSwiper() {
      this.showSwiper = false;
    },
    overrideSearch() {
      // 获取v-model="tempData.searchContent"提交框填写的值
      let searchContent = this.tempData.searchContent;
      if (this.tempData.searchContent.trim() != '') {
        // 在这里添加你的搜索逻辑
        this.listQuery.pn = 1;
        this.listQuery.hotelName = this.tempData.searchContent.trim();
        this.list = [];
      }else{
        this.listQuery = {
          pn: 1,
          ps: 4
        }
      }
      this.getTaskOrderPager();
    },
    viewDetail(item) {
      // 跳转到/Grapher/SignatureDetail页面
      window.location.href = "/Grapher/SignatureDetail?id=" + item.order.id;
    },
  },
  created: function() {},
  components: {
    hshead,
    "van-list": List,
    "van-button": Button,
    //"van-dialog": Dialog.Component,
    [Dialog.Component.name]: Dialog.Component,
    "van-cell-group": CellGroup,
    "van-cell": Cell,
    "van-icon": Icon,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
/deep/ .el-carousel__container {
  position: static !important;
}
/deep/ .el-carousel__arrow {
  font-size: 35px !important;
  font-weight: bold !important;
}
.order-ul {
  // margin-top: -6.2rem;
  // margin-top: 50px;
  background-color: #d8d8d8;
  padding-top: 0.5rem;
  .order-li {
    width: 6.7rem;
    background-color: #ffffff;
    box-shadow: 0rem 1px 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    position: relative;
    .content-box {
      padding: 0.2rem 0.3rem;
      .content-top {
        display: flex;
        margin-bottom: 0.15rem;
        .left-img {
          padding-right: 0.2rem;
          width: 0.62rem;
          img {
            width: 0.62rem;
            height: 0.62rem;
          }
        }
        .center-p {
          width: 4.6rem;
          padding-bottom: 0.4rem;
          .center-p-h1 {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 0.28rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0rem;
            color: #666666;
          }
          .center-p-p {
            height: 0.21rem;
            font-family: PingFangSC-Regular;
            font-size: 0.22rem;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0.4rem;
            letter-spacing: 0rem;
            color: #00bbfb;
          }
        }
        .right-icon {
          flex: 1;
          img {
            width: 0.64rem;
            height: 0.64rem;
            background-color: #ffffff;
          }
        }
      }
      .content-hr {
        height: 1px;
        border-top: 1px solid #000000; /* 设置你需要的颜色 */
        width: 100%;
        margin: 0,0,0,0;
      }
      .button-red {
        float: right;
        background-color: red; /* 设置按钮颜色为绿色 */
        color: white; /* 设置按钮文字颜色为白色 */
        box-shadow: none; /* 移除按钮阴影 */
        border: solid 1px red;
      }
      .button-green {
        float: right;
        background-color: green; /* 设置按钮颜色为绿色 */
        color: white; /* 设置按钮文字颜色为白色 */
        box-shadow: none; /* 移除按钮阴影 */
        border: solid 1px green;
      }
      .content-content {
        display: flex;
        .left-p {
          width: 100%;
          font-family: PingFangSC-Medium;
          font-size: 0.3rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #222222;
          span {
            font-size: 0.28rem;
          }
        }
        .right-p {
          flex: 1;
          text-align: right;
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        margin-bottom: 0.4rem;
      }
      .content-iconp {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.24rem;
        letter-spacing: 0rem;
        color: #494848;
        padding-left: 0.5rem;
        margin-top: 0.2rem;
        word-break: break-all;
        height: 30px;
        display: flex;
        align-items: center;


        &.iconp1 {
          background: url(~@/assets/images/order/1.png) left center no-repeat;
          background-size: 0.2rem 0.22rem;
        }
        &.iconp2 {
          background: url(~@/assets/images/center/menu-icon-10.png) left center no-repeat;
          background-size: 0.19rem 0.24rem;
        }
        &.iconp3 {
          background: url(~@/assets/images/order/3.png) left center no-repeat;
          background-size: 0.22rem 0.21rem;
        }
      }
      .content-iconp-upload {
        display: flex; /* 设置为 flex 布局 */
        justify-content: space-between; /* 使元素在水平方向上均匀分布 */
      }
    }
    .li-btn {
      position: absolute;
      bottom: 0.4rem;
      right: 0.3rem;
      width: 1.7rem;
      height: 0.6rem;
      border-radius: 0.3rem;
      border: solid 1px #00b8f5;
      font-size: 0.24rem;
      text-align: center;
      color: #00b8f5;
      line-height: 0.6rem;
      &:active {
        background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
          linear-gradient(#f2f9fb, #f2f9fb);
        background-blend-mode: normal, normal;
        color: #fff;
      }
    }
    .order-li-bt {
      height: 1.17rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .this-btn {
        width: 1.7rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        border: solid 1px #00b8f5;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.6rem;
        letter-spacing: 0rem;
        color: #00b8f5;
        text-align: center;
        display: block;
        margin: 0 0.3rem;
        &.btn1 {
        }
        &.btn2 {
          background-color: #00b8f5;
          color: #fff;
        }
      }
    }
  }
}
.van-dialog__content {
  padding-top: 10px;
}
.replacerapher .van-dialog__content {
  height: 80%;
}
.grapher-ul {
  width: 100%;
  height: 65%;
  overflow: scroll;
  position: absolute;
  .van-list {
    width: 100%;
  }
  .grapher-li {
    border: 1px solid #f0f6ef;
    padding: 4px 0px;
    font-size: 0.8em;
  }
  .van-loading {
    display: none;
  }
}
.dialog-lshoot-close {
  position: fixed;
  top: 0;
  right: 0;
  font-size: 1.5em;
  color: #ff0000;
}
.ref-box {
  position: fixed;
  right: 0.2rem;
  bottom: 0.2rem;
  opacity: 0.3;
  img {
    width: 1rem;
  }
  &:active {
    opacity: 0.6;
  }
}
.this-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  .this-search-box-left{
    // width: 60%;
    padding: 10rpx 10rpx;
    border-radius: 30rpx;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
      .this-search-input {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 20px;
      font-size: 12px;
      width: 150px;
      margin-left: 15px;
    }
    .my-btn {
      border-radius: 1rem !important;
      background-color: #ffffff !important;
      font-size: 15px !important;
      border-color: transparent;
      height: 18px;
      width: 40px;
      line-height: 20px;
      color: #000000;
    }
  }
  .this-search-box-right{
    // width: 40%;
    padding: 10rpx 10rpx;
    border-radius: 30rpx;
    display: flex;
    align-items: right;
    justify-content: space-between;
    margin: auto;
    .this-search-button-blue {
      margin-right: 2px;
      background-color: blue;
      color: white;
      // height: 30rpx;
      width: 110px;
      height: 0.5rem;
      border-radius: 8px;
      font-size: 0.24rem;
      line-height: 0.2rem;
      // letter-spacing: 0rem;
      border: solid 0px;
      text-align: center;
      display: block;
      margin: 0 0.3rem;
    }
  }
}
.swiper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  .swiper-container {
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.3);
      .swiperItem {
        height: 100vh;
        object-fit: contain; /* 保持图片的比例 */
      }
      .swiperImage {
        // 控制图片的原始比例，然后在页面中不能超出页面的宽度和高度
        width: 100%; /* 让图片的宽度等于容器的宽度 */
        height: 100%; /* 让图片的高度等于容器的高度 */
        object-fit: contain; /* 让图片保持原始比例并且不超过容器的尺寸 */
      }
  }
  .close-button {
    position: absolute;
    top: 1px;
    right: 1px;
    z-index: 99999;
    background-color: transparent !important; /* 设置背景色为透明 */
    border-color: transparent !important; /* 设置边框颜色为透明 */
    font-weight: bold !important; /* 将文字（图标）加粗 */
    color: white !important; /* 设置文字（图标）颜色为白色 */
    font-size: 0.8em !important; /* 将文字（图标）的尺寸放大一倍 */
  }
}
.noMore {
    color: black;
}
</style>


// WEBPACK FOOTER //
// src/views/grapher/signatureList.vue